export default defineAppConfig({
  ui: {
    icons: {
      menu: "far:bars",
      close: "far:xmark",
      check: "far:check",
      chevronDown: "far:chevron-down",
      chevronUp: "far:chevron-up",
      chevronLeft: "far:chevron-left",
      chevronRight: "far:chevron-right",
    },
    header: {
      slots: {
        root: "bg-green-50 border-green-pop text-white",
      },
    },
    container: {
      base: "!px-(--ui-container-inline-padding,var(--spacing-s)) sm:!px-(--ui-container-inline-padding,var(--spacing-m)) max-w-[calc(var(--ui-container, 72rem)+calc(2*var(--ui-container-inline-padding)))]",
    },
    accordion: {
      slots: {
        root: "text-base flex flex-col gap-3",
        item: "border-none hover:contrast-90 px-4",
        trigger: "text-base",
      },
    },
  },
  icon: {
    size: "1.25em",
    mode: "css",
    cssLayer: "base",
  },
});
